import React from "react";
import TopBanner from "../components/TopBanner";
import { CTAButton, CTAButtonWrapper } from "../components/HeroSection";
import { ContentWrapper } from "./InsuranceGuidance";

const TermsAndConditions = ({ openModal }) => {
  React.useEffect(() => {
    document.title = "Terms & Conditions | Wealthies";
  }, []);

  return (
    <>
      <TopBanner content={"Terms & Conditions"} />
      <ContentWrapper>
        <div className="text-content">
          <h3>Terms and Conditions</h3>
          <p>
            These Terms and Conditions govern the use of the Wealthies website.
          </p>
          <p>
            By accessing or using this website, users agree to comply with these
            terms.
          </p>

          <h5>1. Platform Purpose</h5>
          <p>
            Wealthies provides educational information related to insurance and
            facilitates connections between individuals and licensed insurance
            professionals.
          </p>
          <p>
            Wealthies does not act as an insurance company, broker, or insurer.
          </p>

          <h5>2. Insurance Advice</h5>
          <p>
            Insurance advice, policy recommendations, and insurance transactions
            are provided by licensed insurance professionals and insurers.
          </p>
          <p>
            Users should evaluate policy terms carefully before making
            decisions.
          </p>

          <h5>3. User Responsibilities</h5>
          <p>
            Users agree to provide accurate information when submitting
            inquiries through the website.
          </p>
          <p>
            Users must not misuse the platform or attempt to disrupt website
            operations.
          </p>

          <h5>4. Intellectual Property</h5>
          <p>
            All content on the Wealthies website, including text, design,
            graphics, and logos, is the property of Shreeman Assure Services Pvt
            Ltd unless otherwise stated.
          </p>
          <p>Unauthorized reproduction or distribution is prohibited.</p>

          <h5>5. Third-Party Services</h5>
          <p>
            Wealthies may facilitate connections with licensed insurance
            professionals. Wealthies is not responsible for services provided by
            third parties.
          </p>
          <p>
            Users should independently evaluate any insurance product or service
            before purchasing.
          </p>

          <h5>6. Limitation of Liability</h5>
          <p>
            Wealthies provides information for educational purposes only. We are
            not liable for financial decisions made by users based on
            information available on the platform.
          </p>

          <h5>7. Changes to Terms</h5>
          <p>
            We reserve the right to update these Terms and Conditions at any
            time.
          </p>

          <h5>Website Disclaimer</h5>
          <p>
            The information provided on the Wealthies website is for educational
            and informational purposes only.
          </p>
          <p>
            Wealthies does not provide insurance advice, investment advice, or
            financial advisory services.
          </p>
          <p>Wealthies does not sell insurance policies.</p>
          <p>
            Insurance products, policy recommendations, and policy sales are
            handled by licensed insurance professionals and insurance companies.
          </p>
          <p>
            Users should carefully review policy terms and consult licensed
            professionals before making insurance decisions.
          </p>
          <p>
            Wealthies makes reasonable efforts to ensure that information
            provided on the website is accurate; however, we do not guarantee
            the completeness or accuracy of information at all times.
          </p>
          <p>
            Insurance regulations, tax laws, and financial rules may change
            periodically. Users should verify the latest regulations before
            making decisions.
          </p>

          <CTAButtonWrapper>
            <CTAButton onClick={openModal}>
              Get Free Insurance Guidance
            </CTAButton>
          </CTAButtonWrapper>
        </div>
      </ContentWrapper>
    </>
  );
};

export default TermsAndConditions;
